import { render, staticRenderFns } from "./ReglasOperativasIndex.vue?vue&type=template&id=1b38eb89"
import script from "./ReglasOperativasIndex.vue?vue&type=script&lang=js"
export * from "./ReglasOperativasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports